"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getCookie = getCookie;
exports.setCookie = setCookie;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
/* eslint-disable eqeqeq */
function getCookie(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

/**
 *
 * @param {String} CName Cookie Name
 * @param {String} cValue Cookie value
 * @param {Number|Object} paramsOrDate If given as number it behaves like expiry date field
 *   Object default value => secure: false, httpOnly: false expDays: null
 * date number only day
 */
function setCookie(cName, cValue, paramsOrDate) {
  var isParamsObject = (0, _typeof2.default)(paramsOrDate) === 'object';
  var defaultExpDays = isParamsObject ? null : paramsOrDate; // default value, null or paramsOrDate(undefined or dateValue)

  var deafultParams = {
    expDays: defaultExpDays,
    secure: false,
    httpOnly: false
  };
  var params = Object.assign(deafultParams, isParamsObject && paramsOrDate);
  var cookies = cName + '=' + cValue + ';';
  if (params.expDays) {
    var date = new Date();
    // date.setMinutes(expMinute); // only minute
    date.setTime(date.getTime() + params.expDays * 24 * 60 * 60 * 1000); // only day
    var expires = 'expires=' + date.toUTCString();
    cookies += expires + ';';
  }
  if (params.secure) {
    cookies += ' Secure;';
  }
  if (params.httpOnly) {
    cookies += ' HttpOnly;';
  }
  cookies += ' path=/';
  document.cookie = cookies;
}
var _default = exports.default = {
  getCookie: getCookie,
  setCookie: setCookie
};